import { Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import classes from "../analytics.module.css"
import { Delta, DrillTable, DrillTitle } from "../cards/AnalyticsCard"
import { RankBadge, RankColumn, RankTable } from "../cards/RankTable"
import { SalesAnalyticsTopCustomers, TopCustomerRow } from "../types"
import { formatInt, formatMnt, formatPct } from "../utils"

type Props = {
  data: SalesAnalyticsTopCustomers | undefined
  isLoading: boolean
}

export function TopCustomersCard({ data, isLoading }: Props) {
  const { t } = useTranslation(["dashboard"])
  const rows = data?.data.rows ?? []

  const columns: RankColumn<TopCustomerRow>[] = [
    {
      key: "rank",
      header: "#",
      width: "56px",
      render: (_row, idx) => <RankBadge n={idx + 1} />
    },
    {
      key: "name",
      header: t("analytics.tables.partner", { defaultValue: "Харилцагч" }),
      render: row => row.partnerName
    },
    {
      key: "amount",
      header: t("analytics.tables.amount", { defaultValue: "Дүн" }),
      align: "right",
      render: row => <Text component="span" className={classes.amount}>{formatMnt(row.totalAmount)}</Text>
    },
    {
      key: "count",
      header: t("analytics.tables.count", { defaultValue: "Тоо" }),
      align: "right",
      render: row => formatInt(row.orderCount)
    },
    {
      key: "yoy",
      header: "YoY",
      align: "right",
      render: row => {
        const pct = formatPct(row.yoyPct)
        return <Delta sign={pct.sign} text={pct.text} />
      }
    }
  ]

  return (
    <RankTable<TopCustomerRow>
      title={t("analytics.tables.topCustomers", { defaultValue: "Топ 10 харилцагч" })}
      rows={rows}
      columns={columns}
      isLoading={isLoading}
      rowKey={row => row.partnerId}
      renderDrill={row => (
        <>
          <DrillTitle>{row.partnerName} · {t("analytics.tables.productBreakdown", { defaultValue: "Барааны задаргаа" })}</DrillTitle>
          <DrillTable
            headers={[
              t("analytics.tables.product", { defaultValue: "Бараа" }),
              t("analytics.tables.qty", { defaultValue: "Тоо" }),
              t("analytics.tables.amount", { defaultValue: "Дүн" })
            ]}
            rows={row.breakdown.map(b => [
              b.productName,
              `${formatInt(b.qty)} ${t("analytics.tables.pieces", { defaultValue: "ш" })}`,
              formatMnt(b.amount)
            ])}
          />
        </>
      )}
    />
  )
}
